<div *ngIf="!(studioSession$ | async)?.descriptInstant || availableShows$.value?.length === 1" class="show-label">
  <ion-item lines="none" *ngIf="studioSession$ | async">
    <ion-img
      *ngIf="(studioSession$ | async)?.communityEvent !== true"
      [src]="(studioShow$ | async)?.showImg"
      slot="start"></ion-img>
    <ion-img
      *ngIf="
        (studioSession$ | async)?.communityEvent === true &&
        (studioSession$ | async)?.sessionTitle.includes('Office Hours')
      "
      [src]="'assets/images/SC_OfficeHours_Square.png'"
      slot="start"></ion-img>
    <ion-img
      *ngIf="
        (studioSession$ | async)?.communityEvent === true &&
        !(studioSession$ | async)?.sessionTitle.includes('Office Hours')
      "
      [src]="'assets/images/Gradient-Logo-80x80.png'"
      slot="start"></ion-img>

    <ion-label>
      <p class="action-small" id="showTitle">{{ (studioSession$ | async)?.showTitle }}</p>
      <h6 class="bold">
        {{ (studioSession$ | async)?.sessionTitle }}
        <ion-icon
          *ngIf="(studioSession$ | async)?.communityEvent !== true"
          class="format-icon"
          [tooltip]="(studioSession$ | async)?.videoEnabled ? 'Video Session' : 'Audio Session'"
          [src]="
            (studioSession$ | async)?.videoEnabled
              ? '/assets/icons/16px/video.svg'
              : '/assets/icons/32px/recordings-bold.svg'
          "></ion-icon>
      </h6>
      <p
        id="sessionTime"
        class="micro-bold-caps"
        *ngIf="studioSession$ && (studioSession$ | async)?.communityEvent !== true"
        [tooltip]="'Local Time: ' + formattedLocal">
        {{ formattedStart }} -
        {{ formattedEnd }}
      </p>
      <p class="micro-bold-caps" *ngIf="studioSession$ && (studioSession$ | async)?.communityEvent === true">
        {{
          (studioSession$ | async)?.sessionTitle.includes('Office Hours')
            ? 'Every Friday • 1:00 PM - 1:30 PM EST'
            : formattedStart
        }}
      </p>
    </ion-label>
  </ion-item>
  <ion-item lines="none" *ngIf="(studioSession$ | async) === null || (studioSession$ | async) === undefined">
    <ion-img slot="start"><ion-skeleton-text animated></ion-skeleton-text></ion-img>
    <ion-label>
      <p class="action-small"><ion-skeleton-text animated style="width: 40%"></ion-skeleton-text></p>
      <h6 class="bold"><ion-skeleton-text animated></ion-skeleton-text></h6>
      <p class="micro-bold-caps"><ion-skeleton-text animated></ion-skeleton-text></p>
    </ion-label>
  </ion-item>
</div>

<div
  *ngIf="(studioSession$ | async)?.descriptInstant && availableShows$.value?.length > 1"
  class="show-label show-select">
  <ion-item
    lines="none"
    button
    *ngIf="studioSession$ | async"
    tooltip="Switch Shows"
    (click)="openShowSelectMenu($event)">
    <ion-img [src]="(studioShow$ | async)?.showImg" slot="start"></ion-img>

    <ion-label>
      <p class="action-small" id="showTitle">{{ (studioSession$ | async)?.showTitle }}</p>
      <h6 class="bold">
        {{ (studioSession$ | async)?.sessionTitle }}
        <ion-icon class="show-select-icon" src="/assets/icons/24px/arrow-down.svg"> </ion-icon>
      </h6>
      <p
        id="sessionTime"
        class="micro-bold-caps"
        *ngIf="studioSession$ && (studioSession$ | async)?.communityEvent !== true"
        [tooltip]="'Local Time: ' + formattedLocal">
        {{ formattedStart }} -
        {{ formattedEnd }}
      </p>
    </ion-label>
  </ion-item>
  <ion-item lines="none" *ngIf="(studioSession$ | async) === null || (studioSession$ | async) === undefined">
    <ion-img slot="start"><ion-skeleton-text animated></ion-skeleton-text></ion-img>
    <ion-label>
      <p class="action-small"><ion-skeleton-text animated style="width: 40%"></ion-skeleton-text></p>
      <h6 class="bold"><ion-skeleton-text animated></ion-skeleton-text></h6>
      <p class="micro-bold-caps"><ion-skeleton-text animated></ion-skeleton-text></p>
    </ion-label>
  </ion-item>
</div>
